'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var FilterBarComponent = /** @class */ (function () {
    function FilterBarComponent() {
    }
    return FilterBarComponent;
}());
exports.FilterBarComponent = FilterBarComponent;
